import axios, { AxiosResponse } from 'axios'
import Jsona from 'jsona'

import { FeedbackCategoryResource } from '@/models'

const jsonApiDataFormatter = new Jsona()
const includes = ['tracks', 'tracks.owner']

export const getFeedback = (feedbackUuid: string): Promise<AxiosResponse> => axios.get(
    `${process.env.REACT_APP_API_URL}/feedback/${feedbackUuid}`,
    {
        params: {
            include: includes.join(','),
        },
    },
)

export const getFeedbackCategories = (): Promise<AxiosResponse> => axios.get(
    `${process.env.REACT_APP_API_URL}/feedback-categories/`,
    {
        params: {
            include: [],
        },
    },
)

export const patchFeedback = (id: string, remark: string, selectedCategory: FeedbackCategoryResource): Promise<AxiosResponse> => {
    const category = {
        id: selectedCategory.id,
        name: selectedCategory.name,
        type: 'feedback_categories',
    }

    const data = {
        id,
        type: 'feedback',
        remark,
        relationshipNames: ['category'],
        category,
    }

    return axios.patch(
        `${process.env.REACT_APP_API_URL}/feedback/${id}`, jsonApiDataFormatter.serialize({ stuff: data }),
    )
}
